<script setup>

import { textColor } from '@/lib/utils'

const props = defineProps({
  values: {
    type: [Array, null],
    required: true,
  },
  size: {
    type: String,
    required: false,
    default: 'sm',
  },
  style: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  dense: {
    type: Boolean,
    required: false,
    default: false,
  },
  justify: {
    type: String,
    required: false,
    default: 'flex-start',
  },
})

</script>

<template>
  <div :style="{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem', justifyContent: props.justify }">
    <q-chip
      v-for="tag in (props.values || [])"
      :key="tag.id"
      v-bind="tag"
      :label="tag.label || tag.name"
      :size="props.size"
      :dense="props.dense"
      :style="{'background-color': tag.color, 'color': textColor(tag.color), ...props.style }"
      class="chip-template-item"
    />
  </div>
</template>
<style scoped>
.chip-template-item:first-child {
  margin-left: 0;
}
.chip-template-item:last-child {
  margin-right: 0;
}
</style>
